import { useMemo } from 'react';
import { Badge, Tooltip } from 'seagull';
import { useIoContext } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { getServiceDescriptionBadges } from "../../../utils/service-description/getServiceDescriptionBadges";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function BadgesList(props) {
  const {
    service,
    agreementData,
    testid,
    isFreshlyAdded,
    context
  } = props;
  const featureFlags = useFeatureFlags();
  const {
    getNow
  } = useIoContext();
  const now = useMemo(() => getNow(), []);
  const badgesList = getServiceDescriptionBadges(service, agreementData, now, featureFlags, {
    isFreshlyAdded,
    context
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: badgesList.map(_ref => {
      let {
        text,
        intent,
        skin,
        tooltip,
        badgeTestid
      } = _ref;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: tooltip || '',
        placement: "top",
        children: /*#__PURE__*/_jsx(Badge, {
          rounded: true,
          outlined: true,
          skin: skin,
          "data-testid": badgeTestid || testid + "badge-".concat(intent),
          "data-intent": intent,
          children: text
        })
      }, intent);
    })
  });
}